import { render } from "./DurationInput.vue?vue&type=template&id=4b40a4ee&scoped=true"
import script from "./DurationInput.vue?vue&type=script&lang=js"
export * from "./DurationInput.vue?vue&type=script&lang=js"

import "./DurationInput.vue?vue&type=style&index=0&id=4b40a4ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b40a4ee"]])

export default __exports__